export default "__VITE_ASSET__iYqv6ey___"